import React from 'react'

const CssSpinner = (props) => {
  return (
    <div className='has-text-centered'>
      <div className='lds-ellipsis'><div /><div /><div /><div /></div>
    </div>
  )
}

export default CssSpinner



// WEBPACK FOOTER //
// ./src/components/generic/CssSpinner.js